import React, { useState, useEffect } from 'react';
import { Container, Row, Col, Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { projectsApi } from '../services/api';
import { Project } from '../types';
import '../styles/ProjectsSection.css';

const getCategoryLabel = (project: Project): string => {
  if (project.categoriaLabel) return project.categoriaLabel;
  const text = project.titulo.toLowerCase();
  if (text.includes('curso') || text.includes('capacita')) return 'Cursos de capacitação';
  if (text.includes('campo')) return 'Dia de campo';
  if (text.includes('agripensar')) return 'Agripensar';
  if (text.includes('social') || text.includes('ação')) return 'Ações sociais';
  return 'Projetos';
};

const ProjectsSection: React.FC = () => {
  const [projects, setProjects] = useState<Project[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchProjects();
  }, []);

  const fetchProjects = async () => {
    try {
      const data = await projectsApi.getAll();
      if (data && data.length > 0) {
        const recent = data
          .filter(p => p.categoriaLabel !== 'Dia de campo')
          .sort((a, b) => new Date(b.dataProjeto).getTime() - new Date(a.dataProjeto).getTime());
        setProjects(recent);
      } else {
        setProjects([]);
      }
    } catch (error) {
      console.error('Erro ao carregar projetos:', error);
      setProjects([]);
    } finally {
      setLoading(false);
    }
  };

  const getProjectImage = (project: Project): string => {
    if (project.galeriaFotos?.fotos?.length) {
      const main = project.galeriaFotos.fotos.find(f => f.isPrincipal) || project.galeriaFotos.fotos[0];
      return main.url;
    }
    return 'https://via.placeholder.com/600x400?text=Projeto';
  };

  return (
    <section id="projetos" className="projects-section">
      <Container>
        <div className="section-header">
          <span className="section-badge">O que acontece por aqui</span>
          <h2 className="section-title">Projetos e ações sociais</h2>
        </div>

        {loading ? (
          <div className="text-center py-5">
            <div className="spinner-border text-primary" role="status">
              <span className="visually-hidden">Carregando...</span>
            </div>
          </div>
        ) : projects.length === 0 ? (
          <div className="text-center py-5">
            <p className="text-muted">Nenhum projeto disponível no momento.</p>
          </div>
        ) : (
          <>
            <Row className="g-3 mt-2 projects-row-home">
              {projects.map((project) => (
                <Col key={project.id} xs={12} sm={6} lg={3}>
                  <Link to={`/projetos/${project.slug}`} className="project-card-link">
                    <div className="project-card">
                      <div
                        className="project-img-wrapper"
                        style={{ backgroundImage: `url(${getProjectImage(project)})` }}
                        role="img"
                        aria-label={project.titulo}
                      >
                        <span className="project-card-category">
                          {getCategoryLabel(project)}
                        </span>
                      </div>
                      <div className="project-card-body">
                        <h3 className="project-card-title">{project.titulo}</h3>
                        <span className="project-read-more">
                          Saiba mais <span className="arrow">→</span>
                        </span>
                      </div>
                    </div>
                  </Link>
                </Col>
              ))}
            </Row>

            <div className="text-center mt-5">
              <Link to="/projetos">
                <Button variant="primary">
                  Ver todos os projetos
                  <i className="bi bi-arrow-right ms-2"></i>
                </Button>
              </Link>
            </div>
          </>
        )}
      </Container>
    </section>
  );
};

export default ProjectsSection;
